import PropTypes from 'prop-types';
import React from 'react';

import MatchResults from './MatchResults';

export default class MatchResultsRow extends React.PureComponent {
  static propTypes = {
    row: PropTypes.array,
  };
  render() {
    const {row} = this.props;
    const items = [];
    const initRow = row || [];
    for (let i = 0; i < initRow.length; i++) {
      items.push(<MatchResults item={row[i]} key={`matchResults-${i}`} />);
    }
    return <div className="row">{items}</div>;
  }
}
